import script from "./LinkedDocs.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkedDocs.vue?vue&type=script&setup=true&lang=js"

import "./LinkedDocs.vue?vue&type=style&index=0&id=386a412e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386a412e"]])

export default __exports__